import { action } from 'src/store/actions';

export const FETCH_CONFIRMATIONS = 'FETCH_CONFIRMATIONS';
export const REQUEST_CONFIRMATIONS = 'REQUEST_CONFIRMATIONS';
export const SUCCESS_CONFIRMATIONS = 'SUCCESS_CONFIRMATIONS';
export const FAILURE_CONFIRMATIONS = 'FAILURE_CONFIRMATIONS';

export const fetchConfirmations = () => action(FETCH_CONFIRMATIONS);
export const requestFetchConfirmations = () => action(REQUEST_CONFIRMATIONS);
export const requestFetchConfirmationsSuccess = (response: any) => action(SUCCESS_CONFIRMATIONS, { response });
export const requestFetchConfirmationsFailure = (error: any) => action(FAILURE_CONFIRMATIONS, { error });
